import { gql } from "@apollo/client";

export const LIST_MATERIAL_UNIT = gql`
  query GetListMaterialUnit($materialId: ID) {
    getListMaterialUnit(materialId: $materialId) {
      _id
      barcode
      costPerUnit
      imageSrc
      qtyInUnit
      isUse
      remark
      materialId {
        _id
        smallUnitId {
          _id
          unitEnName
          unitKhName
        }
        materialEnName
        materialKhName
        sizeId {
          sizeEnName
          sizeKhName
        }
      }
      unitId {
        _id
        unitKhName
        unitEnName
      }
    }
  }
`;
export const CREATE_LIST_MATERIAL = gql`
  mutation CreateListMaterialUnit($input: ListMaterialUnitInput) {
    createListMaterialUnit(input: $input) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;
export const UPDATE_LIST_MATERIAL = gql`
  mutation UpdateListMaterialUnit($id: ID!, $input: ListMaterialUnitInput) {
    updateListMaterialUnit(_id: $id, input: $input) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;
export const UPDATE_LIST_MATERIAL_UNIT_IS_USE = gql`
  mutation UpdateListMaterialUnitIsUse($id: ID!, $isUse: Boolean) {
    updateListMaterialUnitIsUse(_id: $id, isUse: $isUse) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;
export const DELETE_LIST_MATERIAL_UNIT = gql`
  mutation DeleteListMaterialUnit($id: ID!) {
    deleteListMaterialUnit(_id: $id) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;
